"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Routes = _interopRequireDefault(require("ContentUtils/Routes"));

var _constants = require("./constants");

var allTrueFunctions = function allTrueFunctions(funcs) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return funcs.reduce(function (acc, func) {
      return acc && func.apply(void 0, args);
    }, true);
  };
};

var anyTrueFunctions = function anyTrueFunctions(funcs) {
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return funcs.reduce(function (acc, func) {
      return acc || func.apply(void 0, args);
    }, false);
  };
};

var allFalseFunctions = function allFalseFunctions(funcs) {
  return function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return funcs.reduce(function (acc, func) {
      return acc && !func.apply(void 0, args);
    }, true);
  };
};

var generateIncludedListsURL = function generateIncludedListsURL(listsIds) {
  var filters = [];

  if (listsIds.size > 0) {
    filters.push({
      operator: 'IN',
      property: 'listMemberships.listId',
      values: listsIds.keySeq().toJS()
    });
  }

  return _Routes.default.lists() + "/?filters=" + encodeURIComponent(JSON.stringify(filters));
};

var getInclusionKey = function getInclusionKey(recipientType) {
  if (recipientType === 'lists') {
    return 'mailingListsIncluded';
  } else if (recipientType === 'contacts') {
    return 'vidsIncluded';
  }

  return '';
};

var getExclusionKey = function getExclusionKey(recipientType) {
  if (recipientType === 'lists') {
    return 'mailingListsExcluded';
  } else if (recipientType === 'contacts') {
    return 'vidsExcluded';
  }

  return '';
};

var hasRecipients = function hasRecipients(props) {
  return _constants.RECIPIENT_PROPS.some(function (prop) {
    return props[prop].length > 0;
  });
};

var _default = {
  allTrueFunctions: allTrueFunctions,
  anyTrueFunctions: anyTrueFunctions,
  allFalseFunctions: allFalseFunctions,
  generateIncludedListsURL: generateIncludedListsURL,
  getInclusionKey: getInclusionKey,
  getExclusionKey: getExclusionKey,
  hasRecipients: hasRecipients
};
exports.default = _default;
module.exports = exports.default;